module.exports = __webpack_public_path__ + "static/media/6B.ebebe952.jpg";